import styled from 'styled-components'

const StackStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .stack-tag {
    padding: 4px 8px;
    background: #252D49;
    border-radius: 72px;
    margin-right: 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #8890B7;
    text-transform: lowercase;
  }
`

function Stack({ stack }) {
  if (!stack) return null

  return (
    <StackStyled>
      {stack.map((tag) => (
        <li className="stack-tag" key={tag}>{tag}</li>
      ))}
    </StackStyled>
  )
}

export default Stack
